var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psConfiguration view"},[_c('ps-page-container',{attrs:{"site":{ site: 'Configuración' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }